import React from 'react';
import { Form, Select } from 'antd';
import { Button as AppButton } from '@/components/Button';
import { USER_ROLES, USER_ROLE_LABELS, type UserRole } from '@/utils/roles';
import styles from './ChangeRoleForm.module.scss';

interface ChangeRoleFormValues {
  role: UserRole;
}

interface ChangeRoleFormProps {
  userLabel: string;
  currentRole: UserRole;
  onSubmit: (values: ChangeRoleFormValues) => Promise<void>;
  onCancel: () => void;
}

const roleOptions = Object.values(USER_ROLES).map((r) => ({ value: r, label: USER_ROLE_LABELS[r] }));

export const ChangeRoleForm: React.FunctionComponent<ChangeRoleFormProps> = ({
  userLabel,
  currentRole,
  onSubmit,
  onCancel,
}) => {
  const [form] = Form.useForm<ChangeRoleFormValues>();
  const role = Form.useWatch('role', form);

  return (
    <div>
      <p className={styles.description}>
        Change the role for <strong>{userLabel}</strong>. This controls which parts of the app they can access.
      </p>

      <Form form={form} layout="vertical" onFinish={onSubmit} initialValues={{ role: currentRole }}>
        <Form.Item name="role" label="Role" rules={[{ required: true, message: 'Select a role' }]}>
          <Select options={roleOptions} size="large" />
        </Form.Item>

        <Form.Item className={styles.actionsFormItem}>
          <div className={styles.actions}>
            <AppButton appearance="outline" onClick={onCancel}>
              Cancel
            </AppButton>
            <AppButton appearance="solid" htmlType="submit" disabled={!role || role === currentRole}>
              Change role
            </AppButton>
          </div>
        </Form.Item>
      </Form>
    </div>
  );
};

export default ChangeRoleForm;
